const submissions = new Map<string, number>();
/** Covers checkout, cart and early email capture synchronously before the first submit await. */
export function pauseBlackFridayPricing(checkoutId: string): () => void {
	submissions.set(checkoutId, (submissions.get(checkoutId) ?? 0) + 1);
	let released = false;
	return () => {
		if (released) return;
		released = true;
		const remaining = (submissions.get(checkoutId) ?? 1) - 1;
		if (remaining > 0) submissions.set(checkoutId, remaining);
		else submissions.delete(checkoutId);
	};
}
export function isBlackFridayPricingPaused(checkoutId: string): boolean {
	return submissions.has(checkoutId);
}
